/*
* Report page
*/

import * as KendoCharts from '@progress/kendo-react-charts';
import * as React from 'react';
import * as _ from 'lodash';
import { Table } from 'react-bootstrap';

import * as ReportCharts from '../../charts';
import * as ReportComponents from '../report-components';

export const Render = ({ registerFunc, refFunc, scrollToFunc, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.yearlyReserveExpendituresGraph;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);

    const { formData, association, inventory, currentOrder, currentOrderChart, percentFunded, yearlySummaryData } = reportData;

    const chartData = [{
        name: 'Current Expenditures',
        data: _.map(yearlySummaryData, 're'),
        visible: true
    }];

    // const chartCategories = ReportCharts.getChartYearData(formData.beginYear, formData.calculateYears);    
    const chartCategories = ReportCharts.getChartCategoriesYearDates(formData.beginYear, formData.calculateYears);
    const chartColors = ReportCharts.getBrandedBarChartColors();
    const chartAxisTitleFontConfig = 'bold 20px Arial, sans-serif';
    const chartAxisLabelFontConfig = '12px Arial, sans-serif';
    const chartLegendLabelColorConfig = 'color: #000000';

    const yreChart = (
        <KendoCharts.Chart renderAs={pageConfiguration.kendoCharts.renderAs}>
            <KendoCharts.ChartTitle text="" />
            <KendoCharts.ChartArea height={800} />
            <KendoCharts.ChartLegend labels={{ font: chartAxisLabelFontConfig, padding: 10, color: chartLegendLabelColorConfig }} position="bottom" orientation="horizontal" />
            <KendoCharts.ChartValueAxis>
                <KendoCharts.ChartValueAxisItem
                    title={{ text: 'Annual Totals', font: chartAxisTitleFontConfig, color: chartLegendLabelColorConfig }}
                    labels={{ format: 'c0', font: chartAxisLabelFontConfig, color: chartLegendLabelColorConfig }}
                    line={{ color: '#000000', width: 2 }}
                    majorGridLines={{ color: '#c5c5c5', width: 2 }}
                />
            </KendoCharts.ChartValueAxis>
            <KendoCharts.ChartCategoryAxis>
                <KendoCharts.ChartCategoryAxisItem
                    categories={chartCategories}
                    baseUnit="years"
                    baseUnitStep={1}
                    maxDivisions={16}
                    type="date"
                    majorGridLines={{ width: 0 }}
                    line={{ color: '#000000', width: 2 }}
                >
                    <KendoCharts.ChartCategoryAxisTitle text="Year" font={chartAxisTitleFontConfig} color={chartLegendLabelColorConfig} />
                    <KendoCharts.ChartCategoryAxisLabels font={chartAxisLabelFontConfig} color={chartLegendLabelColorConfig} />
                </KendoCharts.ChartCategoryAxisItem>
            </KendoCharts.ChartCategoryAxis>
            <KendoCharts.ChartSeries>
                {
                    chartData.map((item, idx) => (
                        <KendoCharts.ChartSeriesItem
                            color={chartColors[idx]}
                            key={`yearly-reserve-expenditures-chart-series-${idx}`}
                            type="column"
                            gap={1}
                            spacing={1}
                            data={_.get(item, 'data')}
                            name={_.get(item, 'name')}
                            overlay={{ gradient: 'glass' }}
                        />
                    ))}
            </KendoCharts.ChartSeries>
        </KendoCharts.Chart>
    );

    const page = (
        <ReportPageWithRegister
            title={pageTitle}
            className={className}
            totalPageCount={pageCount}
            showFooter={true}
            footerData={reportData}
        >
            <div className="pdf-page-chart">
                {yreChart}
            </div>
        </ReportPageWithRegister>
    );

    return (
        <div>
            {page}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-yearly-reserve-expenditures-graph-kendo.tsx